import {DefaultInteraction} from "./interaction";

export class DialogueGoInteraction extends DefaultInteraction {
	key() {
		return "dialogue_go"
	}

	interact(interactionData, metadata, onSuccess, onError) {
		window.dispatchEvent(new CustomEvent(`interaction-dialogue-go`, {detail: interactionData}))
	}
}